export default {
    title: 'Adopt trends from panel',
    subtitle: 'Select a panel whose macro trends you want to have evaluated',
    select: {
        label: 'Select panel'
    },
    dialog: {
        content: 'Would you now like to select all macro trends from the "{title}" panel for trend evaluation?',
        title: 'Macro trend selection',
        confirm: 'Yes, select macro trends'
    }
}
